<template>
    <HeaderContent title="Room Status"/>
    <ActionContent ctaText="Add Room Status" @action="showModal" :filterDate="false" :filterModal="false" @search-query="searchData"/>
    <RoomStatusStatistics title="Room Status Statistics" :data="statistics" />
    <RoomStatusForm :modal="modal" :roomStatusData="roomStatus" @update:modal="updateModal" @addOrUpdate="getAll"/>
    <RoomStatusConfirm title="Confirmation" :uuid="roomStatusUuid" @action="deleteData" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
        <template #text>Are you sure to delete this data ?</template>
    </RoomStatusConfirm>
    <RoomStatusDataTable :data="roomStatuses" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import RoomStatusForm from './RoomStatusForm.vue';
import RoomStatusDataTable from '@/components/DataTable.vue';
import RoomStatusStatistics from '@/components/StatisticData.vue';
import RoomStatusConfirm from '@/components/ModalDialog.vue';
import iconHouseCircleCheck from '../../../public/icons/house-circle-check.svg';
import { ref, inject, onMounted } from 'vue';

export default {
    components: {
        HeaderContent,
        ActionContent,
        RoomStatusForm,
        RoomStatusDataTable,
        RoomStatusStatistics,
        RoomStatusConfirm,
    },
    setup() {
        const repositories = inject('repositories')
        const roomStatusRepository = repositories ? repositories.roomStatus : null
        const modal = ref(false)
        const modalConfirm = ref(false)
        const roomStatusUuid = ref(null)
        const roomStatus = ref({})
        const roomStatuses = ref([])

        const headers = ref([
            {
                key: 'no',
                label: 'No'
            },
            {
                key: 'icon',
                label: 'Icon',
                sortable: true
            },
            {
                key: 'name',
                label: 'Name',
                sortable: true
            },
            {
                key: 'action',
                label: 'Actions'
            }
        ])

        const customActions = ref([
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                    getById(item.uuid)
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                    showConfirmModal(item.uuid)
                }
            },
        ])

        const statistics = ref([])

        const getAll = async () => {
            await roomStatusRepository.getAll().then((res) => {
                roomStatuses.value = res.data.data
                statistics.value = [  
                    {
                        label: 'Total',
                        key: 'Room Status',
                        value: res.data.data.length,
                        color: 'primary',
                        icon: iconHouseCircleCheck,
                    }
                ]
            }).catch(err => {
                console.error(err)
            })
        }

        const getById = async (uuid) => {
            await roomStatusRepository.getById(uuid).then((res) => {
                roomStatus.value = res.data.data
                modal.value = true
            }).catch(err => {
                console.error(err)
            })
        }

        const updateModal = (newValue) => {
            modal.value = newValue;
            roomStatus.value  = {}
        }

        const showModal = () => {
            modal.value = true
        }

        const showConfirmModal = (uuid) => {
            modalConfirm.value = true
            roomStatusUuid.value = uuid
        }

        const deleteData = async (actionType, uuid) => {
            console.log(uuid)
            await roomStatusRepository.delete(uuid).then(() => {
                modalConfirm.value = false
                getAll()
            }).catch(err => {
                console.error(err)
            })
        }

        const searchData = async (keyword) => {
            await roomStatusRepository.search(keyword).then((res) => {
                roomStatuses.value = res.data.data
            }).catch(err => {
                console.error(err)
            })
        }

        onMounted(() => {
            getAll()
        })

        return {
            modal,
            modalConfirm,
            roomStatusUuid,
            roomStatus,
            roomStatuses,
            headers,
            customActions,
            statistics,
            updateModal,
            showModal,
            showConfirmModal,
            deleteData,
            getAll,
            getById,
            searchData
        }
    }
}
</script>